<template>
  <div class="dovemed-container">
    <div class="dovemed-wrapper text-center signup-page">
      <div class="signup-container">
        <h2 class="hyper-link mb-4 otherConditions">
          Other Diagnosed Conditions
          <a-tooltip placement="topLeft" overlayClassName="ant-dovemed-tooltip">
            <template slot="title">
              <span> Please add any other medical conditions you may be having in addition to the primary condition. </span>
            </template>
            <!-- <i
              class="fa fa-info-circle"
              aria-hidden="true"
              :style="{
                color: `${currentCircle.color_code} !important`,
                'font-size': '14px',
                position: 'absolute'
              }"
            ></i> -->
            <i class="fa fa-question-circle question-icon" aria-hidden="true" :style="`color:#2A71D4 !important`"></i>
          </a-tooltip>
        </h2>
        <div class="col-md-12 col-sm-12 text-center otherConditionsContent">
          <div class="otherConditionsDescriptions">
            <p class="bold-text m-0">
              {{ authUser.user.role === "patient" ? "Have you been diagnosed with conditions other than" : "Has the patient been diagnosed with conditions other than" }}
              {{
                currentCircle.condition_type
                  .replace("My", "")
                  .replace("Circle", "")
                  .replace("my", "")
                  .replace("circle", "")
                  .trim()
              }}?
            </p>
            <p class="mb-0">You can list them out here.</p>
          </div>
          <div @click="openSymptomsModal" class="add-symptoms">
            <!-- <div class="left-line"></div>
            <hr class="top-line" />
            <hr class="bottom-line" /> -->
            <div class="plus-icon">
              <!-- <img src="../../../assets/images/plus-icon.png" /> -->
              <font-awesome-icon size="1x" class="mr-2" :style="{ color: getPrimaryColor() }" :icon="['fas', 'plus']" />
            </div>
            <span class="addsymtoms-text" :style="{ color: getPrimaryColor() }"> Add Condition </span>
          </div>

          <!-- <div v-if="symptoms.length" class="mt-4 symptoms-list">
            <div class="d-flex display-symptom mt-2" v-for="(item, index) in symptomsList" :key="index">
              <div class="symptoms-wrapper">
                <div class="symptoms-text" :style="{ width: '100%', display: 'flex' }">
                  {{ item }}
                </div>

                <div class="position-relative my-auto">
                  <div class="d-flex align-items-center deleteText cp" @click="() => (showDelete = index)">
                    <font-awesome-icon size="1x" :style="{ color: '#FF9999' }" :icon="['fas', 'trash']" class="mr-2" />
                    Delete
                  </div>
                  <div class="position-absolute delete-popup shadow-card" v-if="showDelete === index">
                    <p class="font-black mb-2">Are you sure you want to delete this？</p>
                    <div class="d-flex justify-content-end">
                      <span class="cancel-box cp rounded" @click="() => (showDelete = null)"> Cancel </span>
                      <span class="ok-box cp rounded" @click.stop="removeOtherCondition(item)" :style="{ 'background-color': getPrimaryColor() }"> Ok </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="flex-column d-flex flex-wrap" v-if="checkForSymptoms(item)">
                <div class="d-flex align-items-center mt-3 symptomsLabel">Symptoms :</div>
                <div class="sympContainer">
                  <div v-for="(symptom, index) in symptoms" :key="index" class="eachSympContainer" v-if="item === symptom.circle_name && symptom.display_name">
                    <div class="mt-3 eachSymptom w-100" :style="{ color: getEffectivenessColor(symptom.effectiveness) }">
                      <div class="symptomWrapper w-100">
                        <div class="symptomName" :style="{ width: '100%', 'text-align': 'initial', color: '#333333' }">
                          {{ symptom.display_name }}
                        </div>
                        <div class="symptomEffectiveness" :style="{ color: getEffectivenessColor(symptom.effectiveness), background: `${getEffectivenessColor(symptom.effectiveness)}25` }">
                          {{ getEffectiveness(symptom.effectiveness) }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> -->

          <SimpleLoader v-if="loading" />

          <div v-else-if="otherDiagnosedList && otherDiagnosedList.length" class="mt-4 symptoms-list">
            <div class="d-flex display-symptom mt-2" v-for="(item, index) in otherDiagnosedList" :key="index">
              <div class="symptoms-wrapper">
                <div class="symptoms-text" :style="{ width: '100%', display: 'flex' }">
                  {{ item.othercondition_details.display_name || "" }}
                </div>

                <div class="position-relative my-auto">
                  <div class="d-flex align-items-center deleteText cp" @click="() => (showDelete = index)">
                    <font-awesome-icon size="1x" :style="{ color: '#FF9999' }" :icon="['fas', 'trash']" class="mr-2" />
                    Delete
                  </div>
                  <div class="position-absolute delete-popup shadow-card" v-if="showDelete === index">
                    <p class="font-black mb-2">Are you sure you want to delete this？</p>
                    <div class="d-flex justify-content-end">
                      <span class="cancel-box cp rounded" @click="() => (showDelete = null)"> Cancel </span>
                      <span class="ok-box cp rounded" @click.stop="removeOtherCondition(item)" :style="{ 'background-color': getPrimaryColor() }"> Ok </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="flex-column d-flex flex-wrap" v-if="item.symptom && item.symptom.length">
                <div class="d-flex align-items-center mt-3 symptomsLabel">Symptoms :</div>
                <div class="sympContainer">
                  <div v-for="symptom in item.symptom" :key="symptom" class="eachSympContainer">
                    <div class="mt-3 eachSymptom w-100" :style="{ color: getEffectivenessColor(symptom.effectiveness) }">
                      <div class="symptomWrapper w-100">
                        <div class="symptomName" :style="{ width: '100%', 'text-align': 'initial', color: '#333333' }">
                          {{ symptom.symptom_details.display_name }}
                        </div>
                        <div class="symptomEffectiveness" :style="{ color: getEffectivenessColor(symptom.effectiveness), background: `${getEffectivenessColor(symptom.effectiveness)}25` }">
                          {{ getEffectiveness(symptom.effectiveness) }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="buttons-group mt-5 text-right col-md-12 col-sm-12 mb-5 p-0">
            <router-link
              :to="{ name: 'UserYourStory', query: { role: authUser.user.role } }"
              class="float-left"
              :style="{ 'background-color': '#FFF !important', display: otherDiagnosedList.length !== 0 ? 'none' : 'inline-block', 'text-decoration': 'none' }"
            >
              <!-- <router-link
              :to="{ path: 'yourStory', query: { role: authUser.user.role } }"
              class="float-left"
            > -->
              <div class="hyper-link cp skipLater" :style="{ color: getPrimaryColor() }">Skip for later</div>
            </router-link>
            <div class="d-flex last-2-btns">
              <!-- <router-link
                :to="{ path: 'treatments', query: { role: authUser.user.role } }"
              > -->
              <router-link :to="{ name: 'UserTreatments', query: { role: authUser.user.role } }">
                <button class="dovemed-button hyper-link treatment-button" :style="{ border: '1px solid #E2E8F0', color: '#47556E', background: '#E2E8F0' }">
                  <!-- @click="
                  () =>
                    this.$router.push({
                      name: 'UserTreatments',
                      query: { role: this.formResponses.role }
                    })
                " -->
                  <!-- @click="$router.go(-1)" -->
                  <span>Back</span>
                </button>
              </router-link>
              <!-- <router-link
                :to="{ path: 'yourStory', query: { role: authUser.user.role } }"
              > -->
              <router-link :to="{ name: 'UserYourStory', query: { role: authUser.user.role } }" :style="{ 'background-color': '#FFF !important' }">
                <a-button
                  :disabled="otherDiagnosedList.length === 0"
                  class="dovemed-button font-white primary-button next-button treatment-button"
                  :style="{ background: getPrimaryColor(), opacity: otherDiagnosedList.length === 0 ? '0.3' : '1', height: '100% !important' }"
                >
                  <span :style="{ color: '#fff !important' }">Next</span>
                </a-button>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <OtherSymptomsModal ref="otherSymptomsModal" />
  </div>
</template>

<script>
import OtherSymptomsModal from "../../Modals/OtherSymptomsModal.vue"
import { RepositoryFactory } from "../../../repositories/RepositoryFactory"
import SimpleLoader from "../../commons/SimpleLoader.vue"

// const AppRepository = RepositoryFactory.get("app")
const UserRepository = RepositoryFactory.get("user")

export default {
  name: "OtherSymptomsSignUp",
  data() {
    return {
      load: false,
      symptoms: [],
      otherSideEffects: [],
      symptomsList: [],
      otherSymptomsList: [],
      loading: false,
      list: [],
      showDelete: null,
      otherDiagnosedList: [],
    }
  },
  components: {
    OtherSymptomsModal,
    SimpleLoader,
  },

  created() {
    this.init()
  },

  watch: {
    symptoms: function(newVal, old) {
      this.symptomsList = new Set()
      this.list = new Set()
      newVal.map(ele => this.symptomsList.add(ele.circle_name))
      newVal.map(ele => this.list.add(ele))
      console.log("symptomsList:", this.symptomsList)
      console.log("list:", this.list)
      console.log("symptoms:", newVal)
    },
  },

  methods: {
    async init() {
      // UserRepository.getSymptoms(this.authUser.user, this.currentCircle.id)
      //   .then(res => {
      //     if (res.data) {
      //       this.symptoms = res.data.data.other_symptoms.length > 0 ? res.data.data.other_symptoms : []
      //       this.otherSideEffects = res.data.data.other_side_effect.length > 0 ? res.data.data.other_side_effect : []
      //     }
      //   })
      //   .catch(err => null)

      try {
        this.loading = true
        const otherCondn = await UserRepository.getOtherConditions(this.authUser.user.id, this.currentCircle.id, this.authUser.user.role)
        console.log("otherCondn.data.data", otherCondn.data.data)
        this.otherDiagnosedList = otherCondn.data.data
        this.loading = false
      } catch (e) {
        this.loading = false
        console.log(e)
      }
    },
    removeOtherCondition(symptom) {
      // removeOtherCondition(symptom) {
      console.log({ symptom })
      this.showDelete = null
      // const payload = { other_symptom: this.symptoms.filter(ele => ele.circle_name !== symptom), other_side_effect: this.otherSideEffects.filter(ele => ele.circle_name !== symptom) }
      // const headers = { Authorization: `Bearer ${this.authUser.user.token}` }
      // const url = `${process.env.BASE_API_URL}/${this.authUser.user.role === "patient" ? "symptoms" : "caregiversymptoms"}/?user_id=${this.authUser.user.id}&circle_id=${this.currentCircle.id}`
      // this.$store.dispatch("Signup/updateNormalUser", { url, payload, headers }).then(() => {
      //   this.symptoms = this.symptoms.filter(ele => ele.circle_name !== symptom)
      //   this.otherSideEffects = this.otherSideEffects.filter(ele => ele.circle_name !== symptom)
      // })
      this.loading = true
      UserRepository.deleteOtherConditions(symptom.id)
        .then(res => {
          this.otherDiagnosedList = this.otherDiagnosedList.filter(sym => sym.id !== symptom.id)
          this.loading = false
        })
        .catch(e => {
          this.loading = false
        })
    },

    getEffectiveness(effectiveness) {
      switch (effectiveness) {
        case "0":
          return "Mild"
        case "50":
          return "Moderate"

        case "100":
          return "Severe"
        default:
          break
      }
    },

    getEffectivenessColor(effectiveness) {
      switch (effectiveness) {
        case "0":
          return "#14DE0D"
        case "50":
          return "#F6B156"

        case "100":
          return "#FF4400"
        default:
          break
      }
    },

    // cancel(e) {
    //   console.log("cancel ->", e)
    // },
    openSymptomsModal() {
      this.$refs.otherSymptomsModal.show("", [], [], this.init)
    },
    checkForSymptoms(disease) {
      return this.symptoms.find(sym => sym.circle_name === disease && sym.display_name)
    },
  },
}
</script>

<style lang="scss" scoped>
.symptoms-text {
  font-weight: 700;
  font-size: 20px;
  text-align: left;
}
.deleteText {
  font-weight: 700;
  font-size: 14px;
  color: #ea3100;
  margin: 4px 0 0 6px;
}
.question-icon {
  font-size: 20px;
  margin: 0 6px;
  position: absolute;
  cursor: pointer;
}
.signup-container {
  .otherConditions {
    color: #1e2945;
    font-weight: 700;
    font-size: 36px;
  }
  .otherConditionsContent {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .otherConditionsDescriptions {
    margin: 8px 0 72px 0;
    p {
      font-size: 16px;
      color: #647490;
      font-weight: 700;
    }
  }
}
.symptomWrapper {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  // padding: 16px;
  padding: 5px 10px;
  margin-right: 5px;
  @media screen and (max-width: 900px) {
    padding: 16px;
  }
}
.symptomsLabel {
  font-weight: 700;
  font-size: 16px;
  color: #0f1734;
}

.symptomName {
  font-weight: 700;
  font-size: 16px;
  color: #0f1734;
}
// .add-symptoms {
//   width: 540px;
//   font-size: 14px;
//   font-weight: 700;
//   padding-top: 24px;
//   padding-bottom: 24px;
//   // margin-bottom: 10px;
//   // margin: 4.5em 0 3em 0;
//   background: #F8FAFD;
//   border: 1px dashed #c4cdd6;
//   border-style: dashed;
//   border-radius: 6px;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   cursor: pointer;
//   color: #2A71D4;
//   .plus-icon, .addsymtoms-text{
//     font-family: 'Lato';
//     font-weight: 700;
//     color: #2A71D4;
//   }
//   .plus-icon{
//     font-size: 30px;
//   }
//   .addsymtoms-text{
//     font-size: 14px;
//     margin: 0 8px;
//   }
//   @media screen and (max-width: 900px) {
//     height: 56px;
//     font-size: 14px;
//     display: flex;
//     justify-content: center;
//     align-items: center;
//   }
// }
.symptoms-list {
  width: 70%;
  @media screen and (max-width: 900px) {
    width: 100%;
  }
}
.buttons-group {
  width: 70%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media screen and (max-width: 900px) {
    width: 100%;
  }
}
.skipLater {
  font-weight: 700;
  font-size: 14px;
}
.display-symptom {
  justify-content: space-between;
  padding: 16px 24px;
  background: #fff;
  border-radius: 5px;
  font-size: 14px;
  font-weight: bold;
  // line-height: 30px;
  display: flex;
  border: 1px solid #e2e8f0;
  flex-direction: column;
  .symptoms-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    .deleteWrapper {
      display: flex;
      align-items: center;
    }
  }
  @media screen and (max-width: 900px) {
    padding: 16px 19px;
  }
}
.treatment-button {
  font-weight: 700;
  font-size: 14px;
  border-radius: 6px;
  @media screen and (max-width: 900px) {
    padding: 10px 50px;
  }

  @media screen and (max-width: 600px) {
    padding: 10px 25px;
  }
}
.icon {
  width: 27px;
  height: 27px;
  border-radius: 50%;
  display: inline-block;
  color: #fff !important;
  padding: 0;
}
.dovemed-wrapper {
  max-width: 800px;
}
.dovemed-button {
  padding: 12px 24px;

  @media screen and (max-width: 900px) {
    padding: 12px 37.5px;
  }
}
.next-button {
  margin-left: 12px;
  color: #fff;
  font-weight: 700;
  font-size: 14px;
  @media screen and (max-width: 900px) {
    margin-left: 5px;
  }
}
.delete-popup {
  top: -100px;
  width: 320px;
  z-index: 1;
  @media screen and (max-width: 900px) {
    right: 0px;
  }
}
.ok-box {
  margin: auto 1em;
  // background: #2A71D4 !important;
  color: white !important;
  padding: 1px 10px;
}
.cancel-box {
  margin: auto 1em;
  background: rgb(226, 232, 240) !important;
  color: black !important;
  padding: 1px 10px;
}
.symptomEffectiveness {
  padding: 4px 8px;
  min-width: 41px;
  border-radius: 4px;
  font-size: 12px;
  width: fit-content;
  display: flex;
  justify-content: center;
  // margin-top: 4px;
}
.eachSymptom {
  min-width: 100px;
  border-radius: 5px;
  font-size: 10px;
  width: fit-content;
  display: flex;
  justify-content: center;
}
.sympContainer {
  display: flex;
  flex-wrap: wrap;
  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
  .eachSympContainer {
    width: 50%;
    @media screen and (max-width: 768px) {
      width: 100%;
    }
  }
}
.last-2-btns {
  justify-content: end;
  flex: 1;
}
@media screen and (max-width: 600px) {
  .float-left {
    width: 100%;
    text-align: left;
  }
  .last-2-btns {
    gap: 10px;
    width: 100%;
    a {
      width: 50% !important;
      button {
        width: 100% !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Signup/UserProfile/otherSymptoms.vue